export default "__VITE_ASSET__t7k65Ru6__"